define('modules/templates/index',['require','exports','module','base/router','./views/template_list','./collections/templates','common/views/dashboard_layout','common/models/appstate'],function(require,exports,module){
  "use strict";
  var Router = require("base/router"),
      TemplateListView = require("./views/template_list"),
      TemplateCollection = require("./collections/templates"),
      DashboardLayout = require("common/views/dashboard_layout"),
      AppState = require("common/models/appstate");

  module.exports = function(moduleManager) {

    var ModuleRouter = Router.extend({
      routes: {
        "templates/:platform": "index"
      },
      index: function(platform){
        if(!AppState.getItem("newPage")){
          this.navigate("/pages", {trigger:true});
        }
        else {
          var dashboard = moduleManager.showInstance(DashboardLayout),
              templateCollection = new TemplateCollection([], { platform: platform});

          this._deactivateTabs();
          dashboard.$top.close();
          dashboard.$content.showInstance(TemplateListView, { collection: templateCollection, platform: platform, newPage: AppState.getItem("newPage"), allPlatforms: AppState.getAllPlatforms() });
          templateCollection.fetch({reset:true});
          //window.TemplateCollection = templateCollection;
        }
      },

      _deactivateTabs: function(){
        $(".navlink").removeClass("active");
      }
    });

    return new ModuleRouter();
  };
});

